export default [
	{
		path: '/pages/investment/customerAnalysis',
		meta: { title: '客户分析' },
		name: '/pages/investment/customerAnalysis',
		component: () => import('@/views/investment/customerAnalysis.vue'),
	},
	{
		path: '/pages/investment/customer',
		meta: { title: '客户管理' },
		name: '/pages/investment/customer',
		component: () => import('@/views/investment/customer.vue'),
	},
	{
		path: '/pages/investment/thread',
		meta: { title: '线索管理' },
		name: '/pages/investment/thread',
		component: () => import('@/views/investment/thread.vue'),
	},
];
